import axios from "axios";

const apiClient = axios.create({
    /*baseURL: "http://localhost:8080/acsmbsaqip",*/
    /*baseURL: "https://stgreports.nsqip.facs.org/acsMbsaqip_api",*/
    baseURL: "https://reports.nsqip.facs.org/acsMbsaqip_api",
    withCredentials: true
});

export default apiClient;